export default "__VITE_ASSET__BwhTBJa9__"